<template>
  <div>
    <b-modal
      size="md"
      v-model="modalShown"
      @ok="onSubmit"
      @show="$v.$reset()"
      :title="titleModal"
      hide-footer="true"
    >
      <form @submit.prevent="submit">
        <b-form-group>
          <label>Familia Material</label>
          <v-select
            :options="supplyfamilyOptions"
            label="name"
            class="style-chooser2"
            :state="
              $v.formDetailedsupply.supplyfamily.$dirty
                ? !$v.formDetailedsupply.supplyfamily.$error
                : null
            "
            v-model="$v.formDetailedsupply.supplyfamily.$model"
            @input="getSupplies"
          >
          </v-select>
        </b-form-group>

        <b-form-group>
          <label>Material</label>
          <v-select
            :options="supplyOptions"
            label="text"
            class="style-chooser2"
            :state="
              $v.formDetailedsupply.supply.$dirty
                ? !$v.formDetailedsupply.supply.$error
                : null
            "
            v-model="$v.formDetailedsupply.supply.$model"
          >
          </v-select>
        </b-form-group>

        <b-form-group>
          <label>Cantidad</label>
          <b-form-input
            type="text"
            v-model="$v.formDetailedsupply.quantity.$model"
            :state="
              $v.formDetailedsupply.quantity.$dirty
                ? !$v.formDetailedsupply.quantity.$error
                : null
            "
            autocomplete="off"
            v-on:keyup="inputSoloNumero"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group>
          <label>Precio Unitario</label>
          <b-form-input
            type="text"
            v-model="$v.formDetailedsupply.unit_price.$model"
            :state="
              $v.formDetailedsupply.unit_price.$dirty
                ? !$v.formDetailedsupply.unit_price.$error
                : null
            "
            autocomplete="off"
            v-on:keyup="inputSoloNumeroDecimal"
          >
          </b-form-input>
        </b-form-group>
        <div class="w-100">
          <b-button
            v-if="selectedRow == null"
            variant="primary"
            @click.prevent="onSubmit"
            class="float-right ml-1"
            >Ingresar
          </b-button>

          <b-button
            v-if="selectedRow != null"
            variant="primary"
            @click.prevent="editRow"
            class="float-right ml-1"
            >Editar
          </b-button>

          <b-button class="float-right ml-1" @click="modalShown = !modalShown"
            >Cancelar</b-button
          >
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  decimal,
  integer,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "CreateDetailedSuppliesModal",
  props: {
    form: {
      type: Object,
      default: {}
    },
    supplyfamilyOptions: {
      type: Object,
      default: {}
    }
  },
  components: {},
  data() {
    return {
      modalShown: false,
      loading: false,
      selectedRow: null,
      formDetailedsupply: {
        index: null,
        supplyfamily: null,
        supply: null,
        quantity: null,
        unit_price: null,
        total_price: null
      },
      submitActive: false,
      supplyOptions: []
    };
  },
  watch: {
    selectedRow: function(val) {
      if (val != null) {
        this.formDetailedsupply.index = this.selectedRow.index;
        this.formDetailedsupply.supplyfamily = this.selectedRow.supplyfamily;
        this.formDetailedsupply.supply = this.selectedRow.supply;
        this.formDetailedsupply.quantity = this.selectedRow.quantity;
        this.formDetailedsupply.unit_price = this.selectedRow.unit_price;
        this.formDetailedsupply.total_price = this.selectedRow.total_price;
      }
    }
  },
  computed: {
    titleModal: function() {
      if (this.selectedRow != null) {
        return "Editar Material";
      } else {
        return "Agregar Material";
      }
    }
  },
  methods: {
    getSupplies: function(obj) {
      this.formDetailedsupply.supply = null;
      if (obj != null) {
        this.supplyOptions = [{ id: "", name: "Cargando..." }];
        this.$axios
          .get(
            "/api/supplies/supply-with-family/select_input/?family_id=" + obj.id
          )
          .then(res => {
            this.supplyOptions = res.data;
          })
          .catch(error => console.log(error));
      }
    },
    resetForm() {
      this.formDetailedsupply.index = null;
      this.formDetailedsupply.supplyfamily = null;
      this.formDetailedsupply.supply = null;
      this.formDetailedsupply.quantity = null;
      this.formDetailedsupply.unit_price = null;
      this.formDetailedsupply.total_price = null;
    },
    async addSupply() {
      let new_index = this.form.detailedSupplies.length + 1;

      const data = {
        index: new_index,
        supplyfamily: this.formDetailedsupply.supplyfamily,
        supply: this.formDetailedsupply.supply,
        quantity: this.formDetailedsupply.quantity,
        unit_price: parseFloat(this.formDetailedsupply.unit_price).toFixed(2),
        total_price: (
          parseFloat(this.formDetailedsupply.quantity) *
          parseFloat(this.formDetailedsupply.unit_price)
        ).toFixed(2)
      };

      this.form.detailedSupplies.push(data);

      this.$toast.success("Ingresado con éxito", "");
      this.modalShown = false;
      this.resetForm();
    },
    onSubmit(evt) {
      this.$v.formDetailedsupply.$touch();
      this.submitActive = true;
      if (this.$v.$invalid == true) {
        this.$toast.warn("Campos restantes en el formulario", "");
      } else {
        this.addSupply();
      }
    },
    editRow() {
      this.$v.formDetailedsupply.$touch();

      if (this.$v.$invalid == true) {
        this.$toast.warn("Campos restantes en el formulario", "");
      } else {
        let elementsIndex = this.form.detailedSupplies.findIndex(
          item => item.index === this.formDetailedsupply.index
        );

        this.form.detailedSupplies[
          elementsIndex
        ].index = this.formDetailedsupply.index;

        this.form.detailedSupplies[
          elementsIndex
        ].supplyfamily = this.formDetailedsupply.supplyfamily;

        this.form.detailedSupplies[
          elementsIndex
        ].supply = this.formDetailedsupply.supply;

        this.form.detailedSupplies[
          elementsIndex
        ].quantity = this.formDetailedsupply.quantity;

        this.form.detailedSupplies[elementsIndex].unit_price = parseFloat(
          this.formDetailedsupply.unit_price
        ).toFixed(2);

        this.form.detailedSupplies[elementsIndex].total_price = (
          parseFloat(this.formDetailedsupply.quantity) *
          parseFloat(this.formDetailedsupply.unit_price)
        ).toFixed(2);

        this.$toast.success("Editado con éxito", "");
        this.modalShown = false;
        this.resetForm();
        this.selectedRow = null;
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    formDetailedsupply: {
      supplyfamily: { required },
      supply: { required },
      quantity: { required, integer },
      unit_price: { required, decimal }
    }
  }
};
</script>

<style>
.style-chooser2 .vs__search::placeholder,
.style-chooser2 .vs__dropdown-toggle,
.style-chooser2 .vs__dropdown-menu {
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 0.6875rem;
  font-weight: 400;
  color: #5c6873;
  border: 1px solid #e4e7ea;
  margin-top: -7px;
  margin-left: 0px;
}
.style-chooser2 .vs__clear,
.style-chooser2 .vs__open-indicator {
  fill: #394066;
}
</style>
